<form>
  <mat-accordion>
    <mat-expansion-panel [expanded]="expandedFilter" (opened)="expandedFilter = true"
      (closed)="expandedFilter = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'internalEquipmentList.filter.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentList.filter.name.label' | translate }}</mat-label>
            <input matInput name="name" [(ngModel)]="filter.name">
          </mat-form-field>
        </div>

        @if (isInternal) {
          <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'internalEquipmentList.filter.status.label' | translate }}</mat-label>
              <mat-select multiple name="idStatus" [(ngModel)]="filter.idStatus" [ngModelOptions]="{standalone: true}">
                @for (item of statuses; track item) {
                  <mat-option [value]="item.id" checkboxPosition="before">
                    {{ 'internalEquipmentStatus.' + item.translation | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        @if (isExternal) {
          <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'internalEquipmentList.filter.client.label' | translate }}</mat-label>
              <mat-select #clientSelect name="idClient" [(ngModel)]="filter.idClient">
                @if (clientSelect.focused) {
                  <mat-select-filter [displayMember]="'name'" [array]="clients"
                    (filteredReturn)="clientsFiltered =$event"
                    [noResultsMessage]="'common.noResults' | translate"
                  [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
                }
                @for (client of clientsFiltered; track client) {
                  <mat-option [value]="client.id">
                    {{client.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'internalEquipmentList.filter.serialNum.label' | translate }}</mat-label>
            <input matInput
              name="serialNum" [(ngModel)]="filter.serialNum">
          </mat-form-field>
        </div>

        @if (isInternal) {
          <div fxFlex="25" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'internalEquipmentList.filter.group.label' | translate }}</mat-label>
              <input matInput
                name="group" [(ngModel)]="filter.group">
            </mat-form-field>
          </div>
        }

        <mat-accordion>
          <mat-expansion-panel expanded="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'internalEquipmentList.filter.advanced.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.type.label' | translate }}</mat-label>
                  <input matInput name="type" [(ngModel)]="filter.type">
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.maker.label' | translate }}</mat-label>
                  <input matInput name="maker" [(ngModel)]="filter.maker">
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.model.label' | translate }}</mat-label>
                  <input matInput name="model" [(ngModel)]="filter.model">
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.certificateNum.label' | translate }}</mat-label>
                  <input matInput name="certificateNum" [(ngModel)]="filter.certificateNum">
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'internalEquipmentList.filter.calibrateDateStart.label' | translate }}</mat-label>
                  <input matInput [matDatepicker]="calibrateDateStartPicker" name="calibrateDateStart"
                    [ngModel]="filter.realizationDateStart"
                    (blur)="saveDate('realizationDateStart', $event)"
                    (dateChange)="saveDate('realizationDateStart', $event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="calibrateDateStartPicker"></mat-datepicker-toggle>
                  <mat-datepicker #calibrateDateStartPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'internalEquipmentList.filter.calibrateDateEnd.label' | translate }}</mat-label>
                  <input matInput [matDatepicker]="calibrateDateEndPicker" name="calibrateDateEndPicker"
                    [ngModel]="filter.realizationDateEnd"
                    (blur)="saveDate('realizationDateEnd', $event)"
                    (dateChange)="saveDate('realizationDateEnd', $event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="calibrateDateEndPicker"></mat-datepicker-toggle>
                  <mat-datepicker #calibrateDateEndPicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'internalEquipmentList.filter.expirationDateStart.label' | translate }}</mat-label>
                  <input matInput [matDatepicker]="expirationDateStartPicker"
                    name="expirationDateStart" [ngModel]="filter.expirationDateStart"
                    (blur)="saveDate('expirationDateStart', $event)"
                    (dateChange)="saveDate('expirationDateStart', $event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="expirationDateStartPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #expirationDateStartPicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'internalEquipmentList.filter.expirationDateEnd.label' | translate }}</mat-label>
                  <input matInput [matDatepicker]="expirationDateEndPicker" name="expirationDateEnd"
                    [ngModel]="filter.expirationDateEnd"
                    (blur)="saveDate('expirationDateEnd', $event)"
                    (dateChange)="saveDate('expirationDateEnd', $event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="expirationDateEndPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #expirationDateEndPicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.variable.label' | translate }} </mat-label>
                  <mat-select multiple [(ngModel)]="filter.idsVariable" name="idsVariable"
                    [ngModelOptions]="{standalone: true}">
                    @for (item of variables; track item) {
                      <mat-option [value]="item.id">
                        {{ 'variable.' + item.translation | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.appType.label' | translate }} </mat-label>
                  <mat-select multiple [(ngModel)]="filter.idsApp" name="idsApp"
                    [ngModelOptions]="{standalone: true}">
                    @for (item of appTypes; track item) {
                      <mat-option [value]="item.id">
                        {{ item.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.supplier.label' | translate }}</mat-label>
                    <input matInput name="supplier" [(ngModel)]="filter.supplier">
                  </mat-form-field>
                </div>
              }

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.equipmentRange.label' | translate }}</mat-label>
                    <input matInput name="equipmentRange" [(ngModel)]="filter.equipmentRange">
                  </mat-form-field>
                </div>
              }

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.useRange.label' | translate }}</mat-label>
                    <input matInput name="useRange" [(ngModel)]="filter.useRange">
                  </mat-form-field>
                </div>
              }

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.resolution.label' | translate }}</mat-label>
                    <input matInput name="resolution" [(ngModel)]="filter.resolution">
                  </mat-form-field>
                </div>
              }

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.tolerance.label' | translate }}</mat-label>
                    <input matInput name="tolerance" [(ngModel)]="filter.tolerance">
                  </mat-form-field>
                </div>
              }

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.calibrationFrequency.label' | translate }}</mat-label>
                    <input matInput name="calibrationFrequency"
                      [(ngModel)]="filter.calibrationFrequency">
                  </mat-form-field>
                </div>
              }

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'internalEquipmentList.filter.acquisitionDateStart.label' | translate }}</mat-label>
                  <input matInput [matDatepicker]="acquisitionDateStartPicker"
                    name="acquisitionDateStart" [ngModel]="filter.acquisitionDateStart"
                    (blur)="saveDate('acquisitionDateStart', $event)"
                    (dateChange)="saveDate('acquisitionDateStart', $event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="acquisitionDateStartPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #acquisitionDateStartPicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'internalEquipmentList.filter.acquisitionDateEnd.label' | translate }}</mat-label>
                  <input matInput [matDatepicker]="acquisitionDateEndPicker" name="acquisitionDateEnd"
                    [ngModel]="filter.acquisitionDateEnd"
                    (blur)="saveDate('acquisitionDateEnd', $event)"
                    (dateChange)="saveDate('acquisitionDateEnd', $event)">
                  <mat-hint>DD/MM/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="acquisitionDateEndPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #acquisitionDateEndPicker
                    >
                  </mat-datepicker>
                </mat-form-field>
              </div>

              @if (isInternal) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'internalEquipmentList.filter.folder.label' | translate }} </mat-label>
                    <mat-select name="idFolder" [(ngModel)]="filter.idFolder">
                      <mat-option [value]="null"> --- </mat-option>
                      @for (item of folders; track item) {
                        <mat-option [value]="item.id">
                          {{ getFolderName(item) }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

              @for (field of customFields; track field) {
                <div fxFlex="25" fxFlex.lt-md="100%">
                  <!-- STRING o ÁREA -->
                  @if (field.idType == 1 || field.idType == 9) {
                    <div>
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [name]="field.name"
                          [ngModel]="field.value" (ngModelChange)="setValue(field, -1, $event)">
                      </mat-form-field>
                    </div>
                  }
                  <!-- NUMÉRICO -->
                  @if (field.idType == 2) {
                    <div>
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ field.name }}</mat-label>
                        <input matInput [name]="field.name"
                          [(ngModel)]="field.value" (ngModelChange)="setValue(field, -1, $event)"
                          type="number" [required]="field.required">
                      </mat-form-field>
                    </div>
                  }
                  <!-- BOOLEAN -->
                  @if (field.idType == 8) {
                    <div>
                      <mat-checkbox [value]="field.value" [checked]="field.value == 'true'"
                        (change)="setValue(field, -1, $event)">
                        {{ field.name }}
                      </mat-checkbox>
                    </div>
                  }
                  @if (field.idType == 6) {
                    <div>
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ field.name }}</mat-label>
                        <mat-select [name]="'idSelectCustom'+field.id" [(ngModel)]="field.value" (ngModelChange)="setValue(field, -1, $event)">
                          @for (sel of field.valueSelect; track sel) {
                            <mat-option [value]="sel.value">
                              {{sel.value}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                </div>
              }

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.resposible.label' | translate
                  }}</mat-label>
                  <mat-select name="idResposible" [(ngModel)]="filter.idResposible">
                    <mat-option [value]="null"> --- </mat-option>
                    @for (item of calibrationResponsibles; track item) {
                      <mat-option [value]="item.id">
                        {{ 'calibrationResponsibleType.' + item.translation | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentEdit.general.resposible.equipment.label' | translate }}</mat-label>
                  <mat-select #responsableSelect name="idResponsibleEquipment" [(ngModel)]="filter.responsibleEquipment">
                    @if (responsableSelect.focused) {
                      <mat-select-filter [displayMember]="'fullName'" [array]="users"
                        (filteredReturn)="usersFiltered =$event" [noResultsMessage]="'common.noResults' | translate"
                      [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
                    }
                    <mat-option [value]="null"> --- </mat-option>
                    @for (user of usersFiltered; track user) {
                      <mat-option [value]="user.username">
                        {{user.fullName}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.equipmentType.label' | translate }} </mat-label>
                  <mat-select multiple [(ngModel)]="filter.idsEquipmentType" name="idsVariable"
                    [ngModelOptions]="{standalone: true}">
                    @for (item of internalEquipmentTypes; track item) {
                      <mat-option [value]="item.id">
                        {{ 'equipmentType.' + item.name | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.action.label' | translate }} </mat-label>
                  <mat-select multiple [(ngModel)]="filter.idsAction" name="idsAction"
                    [ngModelOptions]="{standalone: true}">
                    @for (item of actionTypes; track item) {
                      <mat-option [value]="item.id">
                        {{ 'internalEquipmentEdit.' + item.translation | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'internalEquipmentList.filter.location.label' | translate }}</mat-label>
                  <input matInput name="location" [(ngModel)]="filter.location">
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
          <button mat-raised-button (click)="doFilter()" color="primary">
          {{ 'button.filter' | translate }}</button>
          <button mat-button (click)="cleanWithoutFilter()">{{ 'button.clean' | translate }}</button>
        </div>

      </div>

    </mat-expansion-panel>
  </mat-accordion>
</form>